import React from 'react';

const LoadingPage = () => {
  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000000',
      }}>
      <img
        style={{ width: '50%' }}
        src={`${process.env.PUBLIC_URL}/img/knockLogo.png`}
        alt="logo"
      />
    </div>
  );
};
export default LoadingPage;
